import {
  bindApi,
  checkExistsApi,
  getFontMeApi,
  getOrgByIPApi,
  magicGetFontMeApi,
  oauthLoginApi,
  sendCodeToRegisterLoginApi,
  setTokenApi,
  signUpUserApi,
  unBindApi,
} from '@/services/login';

import { requestForm } from '../utils/requestForm';

// todo 优化

// https://trend.aminer.cn/microtrend-api-beta/ 测试
// https://trend.aminer.cn/microtrend-api/ 生产

const prodApi = {
  LoginPhoneUrl: 'https://api-egg.top3-talent.com/api/oauth/login', // 手机账号登录
  LoginEmailUrl: 'https://api-egg.top3-talent.com/api/oauth/login', // 邮箱账号登录
  checkEmailUrl: 'https://api-egg.top3-talent.com/api/oauth/email/checkExists', // 校验邮箱
  checkPhoneUrl: 'https://api-egg.top3-talent.com/api/oauth/phone/checkExists', // 校验手机号注册
  sendPhoneCodeUrl: 'https://api-egg.top3-talent.com/api/oauth/sendCodeToPhone', // 发送短信验证码
  sendEmailCodeUrl: 'https://api-egg.top3-talent.com/api/oauth/sendCodeToEmail', // 发送短信验证码
  sendEmailCodeByRegisterUrl: 'https://api-egg.top3-talent.com/api/oauth/sendCodeToEmailByRegister', // 发送邮箱验证吗
  sendPhoneCodeByRegisterUrl:
    'https://api-egg.top3-talent.com/api/oauth/sendCodeToPhoneUnRegistered', // 发送短信验证吗
  sendPhoneCodeByRegisterUrl2: 'https://oauth.aminer.cn/api/v2/authenticator/sms/prepareExists', // 发送短信验证吗
  settingPwdUrl: 'https://api-egg.top3-talent.com/api/oauth/resetPwd', // 发送短信验证码
  logoutUrl: 'https://api.top3-talent.com/auth/v1/logout', // 退出登录
  getUserInfo: 'https://api.top3-talent.com/user/v2', //用户信息
  refreshUrl: 'https://api.top3-talent.com/auth/v1/refresh',
  getZhiyinUserInfo: 'https://trend.aminer.cn/microtrend-api/admin/v1/getFontMe', //知因
  setZhiyinToken: 'https://trend.aminer.cn/microtrend-api/admin/v1/setToken', //知因
  updZhiyinEmailBind: 'https://trend.aminer.cn/microtrend-api/aminer-api/api/v0/user/bind', //知因邮箱绑定
  updZhiyinPhoneBind: 'https://trend.aminer.cn/microtrend-api/aminer-api/api/v0/user/bind', // 知因手机绑定
  userMerge: 'https://backend.aminer.cn/api/v0/user/merge', // 合并
  unbindUser: 'https://trend.aminer.cn/microtrend-api/aminer-api/api/v0/user/unBind',
  signUpUserUrl: 'https://trend.aminer.cn/microtrend-api/admin/v1/signUpUser', // 用户自动注册
  sendCodeToRegisterLoginUrl:
    'https://trend.aminer.cn/microtrend-api/aminer-api/bff/api/oauth/sendCodeToRegisterLogin', // 用户自动注册
  codeLoginUrl: 'https://trend.aminer.cn/microtrend-api/aminer-api/bff/api/oauth/login', // 用户自动注册
  codeCheckUrl: 'https://trend.aminer.cn/microtrend-api/aminer-api/bff/api/oauth/phone/checkExists', // 用户自动注册
  magicInfoUrl: 'https://trend.aminer.cn/microtrend-api/aminer-old-api/magic', // 未绑定用户登录，用户信息
  getOrgByIP: 'https://trend.aminer.cn/microtrend-api/admin/v1/getOrgByIP', //ip权限
};

const betaApi = {
  LoginPhoneUrl: 'https://api-egg.top3-talent.com/api/oauth/login', // 手机账号登录
  LoginEmailUrl: 'https://api-egg.top3-talent.com/api/oauth/login', // 邮箱账号登录
  checkEmailUrl: 'https://api-egg.top3-talent.com/api/oauth/email/checkExists', // 校验邮箱
  checkPhoneUrl: 'https://api-egg.top3-talent.com/api/oauth/phone/checkExists', // 校验手机号注册
  sendPhoneCodeUrl: 'https://api-egg.top3-talent.com/api/oauth/sendCodeToPhone', // 发送短信验证码
  sendEmailCodeUrl: 'https://api-egg.top3-talent.com/api/oauth/sendCodeToEmail', // 发送短信验证码
  sendEmailCodeByRegisterUrl: 'https://api-egg.top3-talent.com/api/oauth/sendCodeToEmailByRegister', // 发送邮箱验证吗
  sendPhoneCodeByRegisterUrl:
    'https://api-egg.top3-talent.com/api/oauth/sendCodeToPhoneUnRegistered', // 发送短信验证吗
  sendPhoneCodeByRegisterUrl2: 'https://oauth.aminer.cn/api/v2/authenticator/sms/prepareExists', // 发送短信验证吗
  settingPwdUrl: 'https://api-egg.top3-talent.com/api/oauth/resetPwd', // 发送短信验证码
  logoutUrl: 'https://api.top3-talent.com/auth/v1/logout', // 退出登录
  getUserInfo: 'https://api.top3-talent.com/user/v2', //用户信息
  unbindUser: 'https://trend-beta.aminer.cn/microtrend-api/aminer-api/api/v0/user/unBind',
  // getZhiyinUserInfo: 'https://trend.aminer.cn/microtrend-api/admin/v1/getFontMe', //知因
  // setZhiyinToken: 'https://trend.aminer.cn/microtrend-api/admin/v1/setToken', //知因
  // updZhiyinEmailBind: 'https://trend.aminer.cn/microtrend-api/aminer-api/api/v0/user/bind', //知因邮箱绑定
  // updZhiyinPhoneBind:'https://trend.aminer.cn/microtrend-api/aminer-api/api/v0/user/bind', // 知因手机绑定
  // refreshUrl: "https://api.top3-talent.com/auth/v1/refresh",
  // signUpUserUrl: "https://trend.aminer.cn/microtrend-api/admin/v1/signUpUser", // 用户自动注册

  getZhiyinUserInfo: 'https://trend-beta.aminer.cn/microtrend-api/admin/v1/getFontMe', //知因
  setZhiyinToken: 'https://trend-beta.aminer.cn/microtrend-api/admin/v1/setToken', //知因
  updZhiyinEmailBind: 'https://trend-beta.aminer.cn/microtrend-api/aminer-api/api/v0/user/bind', //知因邮箱绑定
  updZhiyinPhoneBind: 'https://trend-beta.aminer.cn/microtrend-api/aminer-api/api/v0/user/bind', // 知因手机绑定
  userMerge: 'https://backend.aminer.cn/api/v0/user/merge', // 合并
  refreshUrl: 'https://api.top3-talent.com/auth/v1/refresh',
  signUpUserUrl: 'https://trend-beta.aminer.cn/microtrend-api/admin/v1/signUpUser', // 用户自动注册
  sendCodeToRegisterLoginUrl:
    'https://trend-beta.aminer.cn/microtrend-api/aminer-api/bff/api/oauth/sendCodeToRegisterLogin', // 用户自动注册
  codeLoginUrl: 'https://trend-beta.aminer.cn/microtrend-api/aminer-api/bff/api/oauth/login', // 用户自动注册
  codeCheckUrl:
    'https://trend-beta.aminer.cn/microtrend-api/aminer-api/bff/api/oauth/phone/checkExists', // 用户自动注册
  magicInfoUrl: 'https://trend-beta.aminer.cn/microtrend-api/aminer-old-api/magic', // 未绑定用户登录，用户信息
  getOrgByIP: 'https://trend-beta.aminer.cn/microtrend-api/admin/v1/getOrgByIP', //ip权限
};

// todo 测试环境很多 api 调不通，使用生产环境地址，client_id 使用不同环境的
// const betaApi = {
//   // LoginPhoneUrl: 'https://t3api-beta.aminer.cn/egg-test/api/oauth/login', // 手机账号登录
//   // LoginEmailUrl: 'https://t3api-beta.aminer.cn/egg-test/api/oauth/login', // 邮箱账号登录
//   LoginPhoneUrl: 'https://api-egg.top3-talent.com/api/oauth/login', // 手机账号登录
//   LoginEmailUrl: 'https://api-egg.top3-talent.com/api/oauth/login', // 邮箱账号登录
//   checkEmailUrl: 'https://t3api-beta.aminer.cn/egg-test/api/oauth/email/checkExists', // 校验邮箱
//   checkPhoneUrl: 'https://t3api-beta.aminer.cn/egg-test/api/oauth/phone/checkExists', // 校验手机号注册
//   sendPhoneCodeUrl: 'https://t3api-beta.aminer.cn/egg-test/api/oauth/sendCodeToPhone', // 发送短信验证码
//   sendEmailCodeUrl: 'https://t3api-beta.aminer.cn/egg-test/api/oauth/sendCodeToEmail', // 发送短信验证码
//   settingPwdUrl: 'https://t3api-beta.aminer.cn/egg-test/api/oauth/resetPwd', // 发送短信验证码
//   // logoutUrl: 'https://t3api-beta.aminer.cn/auth/v1/logout', // 退出登录
//   logoutUrl: 'https://api.top3-talent.com/auth/v1/logout', // 退出登录
//   refreshUrl: "https://t3api-beta.aminer.cn/auth/v1/refresh",
//   getUserInfo: 'https://t3api-beta.aminer.cn/user/v2', //用户信息
//   getZhiyinUserInfo: 'https://trend.aminer.cn/microtrend-api/admin/v1/getFontMe', //知因
//   setZhiyinToken: 'https://trend.aminer.cn/microtrend-api/admin/v1/setToken', //知因

// };

// 基于环境获取 api
function getAPI() {
  return REACT_APP_ENV == 'prod' ? prodApi : betaApi;
}

// 手机账号登录
export async function loginPhoneService(params: any) {
  return requestForm(getAPI().LoginPhoneUrl, {
    method: 'post',
    payload: params,
  });
}

// 邮箱登录
export async function loginEmailService(params: any) {
  return requestForm(getAPI().checkEmailUrl, {
    method: 'get',
    payload: params,
  });
}

// 校验邮箱
export async function checkEmailService(params: any) {
  return requestForm(getAPI().checkEmailUrl, {
    method: 'get',
    payload: params,
  });
}

// 校验手机号
export async function checkPhoneService(params: any) {
  return requestForm(getAPI().checkPhoneUrl, {
    method: 'post',
    payload: params,
  });
}

// 发送短信验证码
export async function sendCodeService(params: any) {
  return requestForm(getAPI().sendPhoneCodeUrl, {
    method: 'post',
    payload: params,
  });
}

// 发送邮箱验证
export async function sendCodeEmailByRegService(params: any) {
  return requestForm(getAPI().sendEmailCodeByRegisterUrl, {
    method: 'post',
    payload: params,
  });
}

// 发送手机验证
export async function sendCodePhoneByRegService(params: any) {
  return requestForm(getAPI().sendPhoneCodeByRegisterUrl, {
    method: 'post',
    payload: params,
  });
}
// 发送手机验证2
export async function sendCodePhoneByRegService2(params: any) {
  return requestForm(
    getAPI().sendPhoneCodeByRegisterUrl2,
    {
      method: 'post',
      payload: params,
    },
    'application/json',
  );
}

export async function mergePhoneService(params: any) {
  return requestForm(
    getAPI().userMerge,
    {
      method: 'post',
      payload: params,
    },
    'application/json',
  );
}

// 发送短信验证码，用于忘记密码
export async function sendCaptchaByPhone(params: any) {
  return requestForm(getAPI().sendPhoneCodeUrl, {
    method: 'post',
    payload: params,
  });
}

// 发送邮箱验证码，用于忘记密码，绑定邮箱
export async function sendCaptchaByEmail(params: any) {
  return requestForm(getAPI().sendEmailCodeUrl, {
    method: 'post',
    payload: params,
  });
}

// 退出登录
export async function loginOutService(params: any) {
  return requestForm(getAPI().logoutUrl, {
    method: 'post',
    payload: params,
  });
}

// 获取用户信息
export async function getUserInfoService(params: any) {
  return requestForm(getAPI().getUserInfo, {
    method: 'get',
    payload: params,
  });
}

// 获取知因用户信息
export async function getZhiyinUserInfoService(params: any) {
  // return requestForm(getAPI().getZhiyinUserInfo, {
  //   method: 'post',
  //   payload: params,
  // });
  return getFontMeApi(params);
}
// 获取知因用户信息
export async function setZhiyinUserTokenService(params: any) {
  // return requestForm(getAPI().setZhiyinToken, {
  //   method: 'post',
  //   payload: params,
  // });
  return setTokenApi(params);
}

// 绑定邮箱
export async function setZhiyinEmailBindService(params: any) {
  // return requestForm(
  //   getAPI().updZhiyinEmailBind,
  //   {
  //     method: 'post',
  //     payload: params,
  //   },
  //   'application/json;charset=UTF-8',
  // );
  return bindApi(params);
}
// 绑定邮箱
export async function setZhiyinPhoneBindService(params: any) {
  // return requestForm(
  //   getAPI().updZhiyinPhoneBind,
  //   {
  //     method: 'post',
  //     payload: params,
  //   },
  //   'application/json;charset=UTF-8',
  // );
  return bindApi(params);
}

export async function unbindUser(params: any) {
  // return requestForm(getAPI().unbindUser, {
  //   method: 'get',
  //   payload: params,
  // });
  return unBindApi(params);
}

// token 刷新
export async function refreshService(params: any) {
  return requestForm(
    getAPI().refreshUrl,
    {
      method: 'post',
      payload: params,
    },
    'application/json;charset=UTF-8',
  );
}

// 设置密码
export async function settingPwdService(params: any) {
  return requestForm(getAPI().settingPwdUrl, {
    method: 'post',
    payload: params,
  });
}

// 设置密码
export async function sendCodeToRegisterLoginService(params: any) {
  // return requestForm(getAPI().sendCodeToRegisterLoginUrl, {
  //   method: 'post',
  //   payload: params,
  // });
  return sendCodeToRegisterLoginApi(params);
}

// 注册用户
export async function registerService(params: any) {
  // return requestForm(
  //   getAPI().signUpUserUrl,
  //   {
  //     method: 'post',
  //     payload: params,
  //   },
  //   'application/json;charset=UTF-8',
  // );
  return signUpUserApi(params);
}

// 注册用户
export async function codeLoginService(params: any) {
  // return requestForm(
  //   getAPI().codeLoginUrl,
  //   {
  //     method: 'post',
  //     payload: params,
  //   },
  //   'application/json;charset=UTF-8',
  // );
  return oauthLoginApi(params);
}

// 注册用户
export async function codeCheckService(params: any) {
  // return requestForm(
  //   getAPI().codeCheckUrl,
  //   {
  //     method: 'post',
  //     payload: params,
  //   },
  //   'application/json;charset=UTF-8',
  // );
  return checkExistsApi(params);
}

// 未绑定用户登录，用户信息
export async function magicInfoService(params: any) {
  // return requestForm(
  //   getAPI().magicInfoUrl,
  //   {
  //     method: 'post',
  //     payload: params,
  //   },
  //   'application/json;charset=UTF-8',
  // );
  return magicGetFontMeApi(params);
}

// 判断ip权限
// 未绑定用户登录，用户信息
export async function getVipIp() {
  // return requestForm(getAPI().getOrgByIP, {
  //   method: 'post',
  // });
  return getOrgByIPApi();
}
